module.exports = __webpack_public_path__ + "img/BIT_white32.a237516c.jpg";